import css from 'styled-jsx/css';

export default css`
    .halfpx-down {
        top: 0.5px;
    }

    .boon-line-left-before {
        content: '';

        margin-right: -2px;
    }

    .boon-line-left-after {
        content: '';
    }

    .boon-line-right-before {
        content: '';

        margin-left: -2px;
    }

    .boon-line-right-after {
        content: '';
    }
`;
